import {useSelector} from "react-redux";

export const useSelectorAuth = () => useSelector(({auth}) => auth.login);
